<template>
  <b-modal
    id="rename-folder-modal"
    ref="rename-folder-modal"
    centered
    title="Rename Folder"
    ok-title="Save Changes"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    @show="setModalData"
    @hidden="resetModal"
    @ok="saveChanges"
  >
    <b-overlay
      id="overlay-background"
      :show="isLoading"
      variant="white"
      opacity="1"
      rounded="sm"
    >
      <validation-observer
        ref="renameFolderRules"
        tag="form"
      >
        <b-row>
          <b-col
            cols="12"
          >
            <b-form-group
              label="Name"
            >
              <validation-provider
                #default="{ errors }"
                name="Name"
                rules="required"
              >
                <b-form-input
                  v-model="folderForRename.name"
                  placeholder="Name here"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BOverlay,
} from 'bootstrap-vue'

import useFoldersList from '@/views/components/folders-list/useFoldersList'

export default {
  name: 'RenameFolderModal',
  components: {
    ValidationProvider,
    ValidationObserver,

    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BOverlay,
  },
  props: {
    folder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      folderForRename: null,
      isLoading: false,
      required,
    }
  },
  setup() {
    const {
      updateFolder,
    } = useFoldersList()

    return {
      updateFolder,
    }
  },
  methods: {
    setModalData() {
      this.folderForRename = JSON.parse(JSON.stringify(this.folder))
    },
    resetModal() {
      this.folderForRename = null
    },
    saveChanges(bvModalEvt) {
      bvModalEvt.preventDefault()

      return new Promise(() => {
        this.$refs.renameFolderRules.validate().then(success => {
          if (success) {
            const queryParams = {
              id: this.folderForRename.id,
              name: this.folderForRename.name,
              type: this.folderForRename.type,
            }
            this.isLoading = true

            this.updateFolder(queryParams).then(() => {
              this.isLoading = false
              this.$emit('refetchData')
              this.$bvModal.hide('rename-folder-modal')
            })
          }
        })
      })
    },
  },
}
</script>
